<section id="maincontent" class="page-main container cart-modern-wrapper">
    <a id="contentarea" tabindex="-1"></a>
    <div class="row">
        <div class="row column main p-0 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="clr"></div>
            
            <!-- Left Column: Cart Items -->
            <div class="cart-container col-md-8 p-0 uf_cartleftbox uf_cart_container cart-card cart-card--items">
                <div class="cart-card-header d-flex justify-content-between align-items-center">
                    <h2 class="cart-title">
                        <i class="material-icons-outlined cart-title-icon" aria-hidden="true">shopping_cart</i>
                        Cart Items <span class="cart-item-count">({{getTotalItemCount()}})</span>
                    </h2>
                    <button class="cart-clear-all" *ngIf="cartListDetails?.length" (click)="clearAllItems()">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                        <span>Clear All</span>
                    </button>
                </div>
                
                <input type="hidden" id="uf_mmtdetailurl" value="https://udesignapi.utsavfashion.com/api/v1/mmt/get.svc/getdetails">
                <input type="hidden" id="totalshipamt" value="0">
                
                <form action="https://www.utsavfashion.com/checkout/cart/updatePost/" method="post" id="form-validate" class="form form-cart" novalidate="novalidate">
                    <input name="form_key" type="hidden" value="iqOHv1Upl97Gkn6q">
                    
                    <div class="cart-items-list">
                        <div class="cart-item-card" *ngFor="let item of cartListDetails; let i = index">
                            <!-- Product Image -->
                            <div class="cart-item-image">
                                <a [title]="item?.productId?.productName" tabindex="-1" class="product-item-photo" (click)="navigateToProduct(item?.productId?._id)" style="cursor: pointer;">
                                    <img class="product-image-photo" [src]="item?.productId?.thumbnail" loading="lazy" [alt]="item?.productId?.productName">
                                </a>
                                <!-- Remove Icon (top-right corner of image) -->
                                <button class="cart-item-remove" (click)="removeCartList(item?._id)" aria-label="Remove item">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                            </div>
                            
                            <!-- Product Details Group (Left) -->
                            <div class="cart-item-details-group">
                                <h3 class="cart-item-name" (click)="navigateToProduct(item?.productId?._id)" style="cursor: pointer;">{{item?.productId?.productName}}</h3>
                                <p class="cart-item-size" *ngIf="item?.priceSizeDetails?.size || item?.priceSizeDetails?.value">
                                    Size/Value: {{item?.priceSizeDetails?.size || item?.priceSizeDetails?.value}}
                                </p>
                                <p class="cart-item-sku">{{item?.productId?.sku || item?.productId?.productCode}}</p>
                                
                                <div class="cart-item-price-group">
                                    <span class="cart-item-unit-price">
                                        <span *ngIf="item?.isDealActive" class="cart-price-original">{{getPrice(item?.priceSizeDetails?.price | currency:"ZAR":"R")}}</span>
                                        <span [ngClass]="{'cart-price-deal': item?.isDealActive, 'cart-price-regular': !item?.isDealActive}" class="cart-price-value">
                                            {{getPrice(item?.isDealActive ? item?.dealPrice : item?.priceSizeDetails?.price | currency:"ZAR":"R")}}
                                        </span>
                                    </span>
                                    <span class="cart-price-each-text">
                                        Each: {{getPrice(getActualPrice(item) | currency:"ZAR":"R")}}
                                    </span>
                                </div>
                            </div>
                            
                            <!-- Quantity Control (Middle) -->
                            <div class="cart-item-quantity-group">
                                <div class="cart-qty-wrapper">
                                    <span class="cart-qty-label">Quantity:</span>
                                    <div class="cart-qty-controls">
                                        <button class="cart-qty-btn cart-qty-btn--minus" [disabled]="item.quantity <= 1" (click)="updateCartValue(item?._id, item?.priceSizeDetails, item.quantity - 1, item.quantity, i, item?.availableQuantity)">
                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                        <input type="number" class="cart-qty-input" [min]="1" [max]="item?.availableQuantity || 999" [(ngModel)]="item.quantity" [ngModelOptions]="{standalone:true}" (input)="updateCartValue(item?._id, item?.priceSizeDetails, item.quantity, item.quantity, i, item?.availableQuantity)" maxlength="5">
                                        <button class="cart-qty-btn cart-qty-btn--plus" [disabled]="item.quantity >= (item?.availableQuantity || 0)" (click)="updateCartValue(item?._id, item?.priceSizeDetails, item.quantity + 1, item.quantity, i, item?.availableQuantity)">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Line Item Total (Right) -->
                            <div class="cart-item-total-group">
                                <span class="cart-item-total-price">
                                    {{getPrice((item?.isDealActive ? item?.dealPrice : item?.priceSizeDetails?.price) * item.quantity | currency:"ZAR":"R")}}
                                </span>
                            </div>
                            
                            <!-- Error Message -->
                            <div class="cart-item-error-line" *ngIf="erorMessageArr[i]">
                                <span class="cart-error-text">{{erorMessageArr[i]}}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!-- Right Column: Order Summary -->
            <div id="uf_cartdockable" class="col-md-4 uf_cartdockable">
                <div class="order-summary-card">
                    <div class="order-summary-header">
                        <i class="fa fa-tag order-summary-icon" aria-hidden="true"></i>
                        <h2 class="order-summary-title">Order Summary</h2>
                    </div>
                    
                    <div class="order-summary-content">
                        <div class="order-summary-row">
                            <span class="order-summary-label">Subtotal <span class="order-summary-item-count" *ngIf="cartListDetails?.length">({{getTotalItemCount()}} {{getTotalItemCount() === 1 ? 'item' : 'items'}})</span></span>
                            <span class="order-summary-value">{{getPrice(calculateSubtotal() | currency:"ZAR":"R")}}</span>
                        </div>
                        
                        <div class="order-summary-row" *ngIf="calculateDiscount() > 0">
                            <span class="order-summary-label">Discount</span>
                            <span class="order-summary-value order-summary-discount">-{{getPrice(calculateDiscount() | currency:"ZAR":"R")}}</span>
                        </div>
                        
                        <div class="order-summary-row order-summary-shipping">
                            <span class="order-summary-label">Shipping</span>
                            <span class="order-summary-value order-summary-shipping-free" *ngIf="getShippingCharge() === 0">FREE</span>
                            <span class="order-summary-value" *ngIf="getShippingCharge() > 0">{{getPrice(getShippingCharge() | currency:"ZAR":"R")}}</span>
                        </div>
                        
                        <div class="order-summary-divider"></div>
                        
                        <div class="order-summary-row">
                            <span class="order-summary-label">Total</span>
                            <span class="order-summary-value">{{getPrice(calculateTotal() | currency:"ZAR":"R")}}</span>
                        </div>
                        
                        <div class="order-summary-row order-summary-total">
                            <span class="order-summary-label-total">Grand Total</span>
                            <span class="order-summary-value-total">{{getPrice(calculateGrandTotal() | currency:"ZAR":"R")}}</span>
                        </div>
                    </div>
                    
                    <div class="order-summary-actions">
                        <button type="button" class="btn-checkout" (click)="navigateToaddresss()" title="Proceed to Checkout" aria-label="Proceed to Checkout">
                            <span>Proceed to Checkout</span>
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                        
                        <button type="button" class="btn-continue-shopping" (click)="continueShopping()" title="Continue Shopping" aria-label="Continue Shopping">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                            <span>Continue Shopping</span>
                        </button>
                    </div>
                    
                    <div class="order-summary-trust">
                        <div class="trust-item">
                            <i class="fa fa-shield trust-icon trust-icon-shield" aria-hidden="true"></i>
                            <span class="trust-text">Your information is protected and secure</span>
                        </div>
                        <div class="trust-item">
                            <i class="fa fa-truck trust-icon trust-icon-truck" aria-hidden="true"></i>
                            <span class="trust-text">Free returns within 30 days</span>
                        </div>
                        <div class="trust-item">
                            <i class="fa fa-clock-o trust-icon trust-icon-clock" aria-hidden="true"></i>
                            <span class="trust-text">Responsive Customer Support</span>
                        </div>
                    </div>
                    
                    <div class="order-summary-delivery-option">
                        <p class="text-center">You can choose delivery options <a class="deliveryLink" (click)="openDeliveryModal()">here.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="modal fade" id="modalDeliveryConfirmation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content ggg position-relative" style="padding:30px 10px">
            <i class="fa fa-times position-absolute colorTheme" data-dismiss="modal"></i>
            <h2>Delivery Options</h2>

            <div class="table-responsive-lg">
                <table class="table">

                    <tbody>
                        <tr *ngFor="let item of optionList">
                            <td scope="row"><input type="radio" (change)="onSelectDeliveryOption(item)"
                                    name="deliveryOption" [checked]="item?.deliveryType == payOutDetail?.deliveryMode">
                            </td>
                            <td class="price-excluding-tax"> {{item?.deliveryOption}}</td>
                            <td class="price-excluding-tax">{{item.description}}</td>
                            <td class="disc_price" *ngIf="item?.deliveryAmount">{{item?.deliveryAmount &&
                                getPrice(item?.deliveryAmount | currency:"ZAR":"R")}}</td>
                            <td class="disc_price" *ngIf="!item?.deliveryAmount">Free</td>
                        </tr>
                    </tbody>

                </table>
            </div>
            <!-- <form id="deliveryForm">
                <label style="margin-bottom: 8px;" *ngFor="let item of optionList">
                    <input type="radio" (change)="onSelectDeliveryOption(item)" name="deliveryOption"
                        [checked]="item?.deliveryType == payOutDetail?.deliveryMode">
                    {{item?.deliveryOption}} - {{item.description}}
                    <span class="disc_price" *ngIf="item?.deliveryAmount">{{item?.deliveryAmount &&
                        getPrice(item?.deliveryAmount | currency:"ZAR":"R")}}</span>
                    <span class="disc_price" *ngIf="!item?.deliveryAmount">Free</span>
                </label>
                <br>

                <br>
            </form> -->


            <div class="modal-body d-flex justify-content-center mb-4">

                <button type="button" (click)="onConFirm()" class="btn btn-primary btn-theme" style="color: white;">
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>